import MedicaidPlan from './MedicaidPlan';

export default MedicaidPlan;
